import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React, { useCallback, useRef } from 'react';
import useDuperbrowseLink from '../hooks/useDuperbrowseLink';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { getDeviationUrl } from '../../DeviationViews/_helpers';
import { useBiDataForDeviationLink } from './useBiDataForDeviationLink';
import { getDeviationEntityId } from '../../redux/normalizr/schemas/deviation';
import { usePrimaryTier } from '../../Tier/PrimaryTierContext';
import { useSubscribeButton } from '../../Button/SubscribeButton/useSubscribeButton';
import { useDeviationBlockType } from '../../DeviationViews/Thumb/hooks/useDeviationBlockType';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
const DeviationLink = (_param)=>{
    var { deviation , onClick: onClickProp , children , overrideHref , overrideAction , extraBiData , disableScrollRestoration , canLinkToStash =false  } = _param, restProps = _object_without_properties(_param, [
        "deviation",
        "onClick",
        "children",
        "overrideHref",
        "overrideAction",
        "extraBiData",
        "disableScrollRestoration",
        "canLinkToStash"
    ]);
    const ref = useRef();
    const linkBiData = useBiDataForDeviationLink(deviation, extraBiData);
    const tier_to_checkout = useFlag('tier_to_checkout');
    const blockType = useDeviationBlockType(deviation);
    const tier = usePrimaryTier(deviation);
    const { onClick: onSubscribeClick  } = useSubscribeButton(tier);
    const onClick = useCallback((e)=>{
        switch(overrideAction){
            // If this deviation is tier-locked, direct the user to
            // checkout for the primary tier by "pressing" Subscribe
            case 'tier-subscribe':
                if (tier_to_checkout && tier && onSubscribeClick && blockType === 'subsOnly') {
                    e.preventDefault();
                    onSubscribeClick(e);
                }
                break;
            default:
                break;
        }
    }, [
        tier_to_checkout,
        overrideAction,
        tier,
        onSubscribeClick,
        blockType
    ]);
    const onDuperbrowseClick = useDuperbrowseLink(getDeviationEntityId(deviation), ref, onClick, disableScrollRestoration);
    if (!deviation.isPublished && !canLinkToStash) {
        return /*#__PURE__*/ React.createElement("span", {
            className: restProps.className,
            style: restProps.style
        }, children);
    }
    return /*#__PURE__*/ React.createElement(BiLink, _extends({
        "data-hook": BiDataHook.DEVIATION_LINK,
        href: overrideHref || getDeviationUrl(deviation),
        biData: linkBiData,
        onClick: onDuperbrowseClick,
        // the undefined here is needed to keep react typings from going nuts
        innerRef: (node)=>ref.current = node || undefined
    }, restProps), children);
};
DeviationLink.displayName = 'DeviationLink';
export default DeviationLink;
